import api from "../api/api";

const registerFcmToken = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/firebase/register/fcm",data,
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}



const notificationServices = {
    registerFcmToken
}
export default notificationServices;